export default interface AuthorizedCarrierTransportOption {
  readonly authorizedCarrierId?: number;
}

export const AuthorizedCarrierTransportOptionInital: AuthorizedCarrierTransportOption = {};
